import React from 'react';
import AssetWrapper, { AssetWrapperProps } from 'atoms/Asset/AssetWrapper';
import VerticalContentCard, { VerticalContentCardProps } from './VerticalContentCard';

export interface VerticalContentCardWithAssetProps {
  verticalContentCardProps: Omit<VerticalContentCardProps, 'children'>;
  assetWrapperProps: AssetWrapperProps;
}

const VerticalContentCardWithAsset = ({
  verticalContentCardProps,
  assetWrapperProps,
}: VerticalContentCardWithAssetProps): JSX.Element => {
  return (
    <VerticalContentCard {...verticalContentCardProps}>
      <AssetWrapper {...assetWrapperProps} />
    </VerticalContentCard>
  );
};

export default VerticalContentCardWithAsset;
